<script lang="ts">
    import { language } from "src/lang";
    import SettingPage from "src/lib/UI/GUI/SettingPage.svelte";
    import SettingTabs from "src/lib/UI/GUI/SettingTabs.svelte";
    import SettingRenderer from "../SettingRenderer.svelte";
    import {
        displayOtherSettingsItems,
        displaySizeSettingsItems,
        displayThemeSettingsItems,
    } from "src/ts/setting/displaySettingsData.svelte";
    import { settingsJumpTab } from "src/ts/setting/settingsSearch";

    let submenu = $state(0);

    // 설정 검색 결과에서 온 서브탭 점프 consume (menu 3 = 화면·테마)
    $effect(() => {
        const t = $settingsJumpTab;
        if (t && t.menu === 3) {
            submenu = t.tab;
            settingsJumpTab.set(null);
        }
    });
</script>

<SettingPage title={language.display}>
<SettingTabs
    tabs={[
        { label: language.theme, value: 0 },
        { label: language.sizeAndSpeed, value: 1 },
        { label: language.others, value: 2 },
    ]}
    bind:selected={submenu}
/>

{#if submenu === 0}
    <SettingRenderer items={displayThemeSettingsItems} />
{:else if submenu === 1}
    <SettingRenderer items={displaySizeSettingsItems} />
{:else if submenu === 2}
    <SettingRenderer items={displayOtherSettingsItems} />
{/if}
</SettingPage>
